(function ($) {

RVwys.plugin['Paragraph'] = true;
// numberingbullets
RVwys.addButtonStarteByTags('numbering','ol');
RVwys.addButtonStarteByTags('bullets','ul');

// Align
RVwys.addButtonStarteByTags('bold','strong');
RVwys.addButtonStarteByTags('italic','em');
RVwys.addButtonStarteByTags('bold','b');

 $(document).bind('editorReady',function(){

	 $('.numberingbullets').click(function(){
		 if (!$(this).attr('id').match(/_ena/img)) {
			 var oNotactiveTag = {};
			 oNotactiveTag['h6'] = true;
			 oNotactiveTag['h5'] = true;
			 oNotactiveTag['h4'] = true;
			 oNotactiveTag['h3'] = true;
			 oNotactiveTag['h2'] = true;
			 oNotactiveTag['h1'] = true;
			 var cmd = $(this).attr('cmd');
			 if(RVwys.currentEditor) {
				 $('.numberingbullets').each(function(){
					 if ($(this).attr('cmd') != cmd) {
						 RVwys.setNormalButtonStarteByOne($(this));
					 }
				 });

				 RVwys.execDesignMode($(this).attr('cmd'), false, null);
				 RVwys.switchButtonStarte($(this));
				 if ($(this).attr('cmd') == 'insertunorderedlist') {
					 var range = RVwys.getRange();
					 var objUL = RVwys.getParentTable($(range.startContainer).parent(),'ul');
					 objUL.addClass('disc');
					 objUL.children().attr("style","list-style-position: inside;");
				 }
				// RVwys.switchButtonStarteGroup($(this),'numberingbullets');
			 }
		 }
	 });
	 


		$('.indent').click(function(){
			if (!$(this).attr('id').match(/_ena/img)) {
				var oNotactiveTag = {};
				oNotactiveTag['h6'] = true;
				oNotactiveTag['h5'] = true;
				oNotactiveTag['h4'] = true;
				oNotactiveTag['h3'] = true;
				oNotactiveTag['h2'] = true;
				oNotactiveTag['h1'] = true;
				var cmd = $(this).attr('cmd');
				if(RVwys.currentEditor) {
					var fBody = $('#frameBody').contents();
					RVwys.execDesignMode(cmd, false, null);
					fBody.find('blockquote').css('font-style','normal');
				}
			}
		});
		

		 $('.setSpacing').click(function() {
			 var range = RVwys.getRange();
			 var obj = $(this);
			 var tagParent = RVwys.getRangeParent();
			 tagParent.css({'lineHeight':obj.attr('set')});
			 var eleRange = $(range.commonAncestorContainer);
			 eleRange.children().each(function(){
				 $(this).css({'lineHeight':obj.attr('set')});
			 });

		 });
	 

		 $('.align').click(function(){
			 if (!$(this).attr('id').match(/_ena/img)) {
				 var oNotactiveTag = {};
				 var oCommand = {};
				 oNotactiveTag['body'] = true;
				 oCommand['left'] = 'JustifyLeft';
				 oCommand['center'] = 'JustifyCenter';
				 oCommand['right'] = 'JustifyRight';
				 oCommand['justify'] = 'Justifyfull';
				 if(RVwys.currentEditor) {
					 var range = RVwys.getRange();
					 if(range.startContainer) {
						 var tagParent = $(range.startContainer).parent();	 
					 } else {
						 $(RVwys.currentiFrame).focus();
						 tagParent = $(range.parentElement());
					 }
					 if (!oNotactiveTag[tagParent.get(0).tagName.toLowerCase()]) {
						 if(!tagParent.get(0).className.match(/RVEditor/ig)) {
							 RVwys.execDesignMode(oCommand[$(this).attr('cmd')], false, null);
						 }
					 }
					 RVwys.switchButtonStarteGroup($(this),'align');
				 }
			 }
		 });
	 
	
 });
 

 RVwys.designViewAddEvent('mouseup',function(e){
	 var tagParent = RVwys.getRangeParent();
	 if (tagParent) {
		 setTimeout(function(){
			 RVwys.activeAlginment(tagParent);
		 },50);
	 }

 });
 
 RVwys.designViewAddEvent('keyup',function(e){
	 var tagParent = RVwys.getRangeParent();
	 if (tagParent) {
		 setTimeout(function(){
			 RVwys.activeAlginment(tagParent);
		 },50);
	 }

 });

 RVwys.activeAlginment = function(obj){
	 if (obj.get(0).tagName.toLowerCase() != 'body') {
		 var tagNotActive = {};
		 tagActive['div'] = true;
		 tagActive['p'] = true;
		 tagActive['h1'] = true;
		 tagActive['h2'] = true;
		 tagActive['h3'] = true;
		 tagActive['h4'] = true;
		 tagActive['h5'] = true;
		 tagActive['h6'] = true;
		 var isTag = tagActive[obj.get(0).tagName.toLowerCase()];
		 if(!isTag) {
			 this.activeAlginment(obj.parent());
			 return false;
		 }
		 var id ;
		 var elm = parent.$('.wys-rowTwo-block4-00');		 
		 if(obj.attr('align') == undefined ) {

			 switch (obj.css('textAlign')) {
			 case 'left':
			 case 'right':
			 case 'center':
			 case 'justify':
				 id =  'wys-'+obj.css('textAlign');
				 break;
			 case 'start':
			 default:
				 id =  'wys-left';
				 break;
			 }
		 } else {
			id = 'wys-'+obj.attr('align');
		 }
		 
		 RVwys.activeButtonStarte(id,elm);
	 }
 };
 

})(jQuery);